import { forwardRef } from "react";
import { InputProps } from "./types";
import { InputLabel } from "../input-label";
import styles from "./styles.scss";

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, subLabel, containerClassName, mandatory, ...props }, ref) => (
    <InputLabel
      label={label}
      subLabel={subLabel}
      labelClassName={containerClassName}
      mandatory={mandatory}
    >
      <input ref={ref} className={styles.input} {...props} />
    </InputLabel>
  ),
);
